import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import BootstrapVue from "bootstrap-vue";
import "@/validator/validator.js";
import VueI18n from "vue-i18n";

Vue.use(BootstrapVue);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "ja",
  messages: {
    ja: require("@/i18n.json"),
    en: require("@/i18n-en.json")
  }
});

new Vue({
  router,
  store,
  i18n: i18n,
  render: h => h(App)
}).$mount("#app");
